/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * Likes object.
 *
 * @author Rodolfo Thiede <rodolfo@habtium.com>
 * @author Víctor Díaz <victor@axiomer.com>
 * @author Fran Torregrosa <fran@axiomer.com>
 */
var Likes = {
	init: function (path) {
		$('.likes-' + path).each(function () {
			var button = $(this);
			Api.get('/likes/status/' + path + '/' + button.data('id'), {}, function (r) {
				if (App.isLogged()) {
					if (r.liked)
						button.attr('data-liked', 1).addClass('active');
					else
						button.attr('data-liked', 0);
				} else
					button.addClass('disabled');
				
				if (path == 'profile' && button.data('id') == App.account_id)
					button.addClass('disabled');
				
				button.html('<span class="glyphicons glyphicons-' + (path == 'profile' ? 'heart' : 'heart') + '"></span> ' + (r.amount > 0 ? '<span class="likes-count">' + r.amount + '</span>' : ''));
			});
		});
		
		$('.likes-' + path).click(function () {
			var button = $(this);
			if (App.isLogged()) {
				if (button.data('liked') == 0) {
					Api.post('/likes/' + path + '/' + button.data('id'), {}, function (r) {
						if (r.success)
							button.addClass('active').attr('data-liked', 1).children('.likes-count').html(parseInt(button.children('.likes-count').html()) + 1);
					});
				} else if (button.data('liked') == 1) {
					Api.delete('/likes/' + path + '/' + button.data('id'), {}, function (r) {
						if (r.success)
							button.removeClass('active').attr('data-liked', 0).children('.likes-count').html(parseInt(button.children('.likes-count').html()) - 1);
					});
				}
			}
		});
	},
};